export default __webpack_public_path__ + "static/media/us-mp.a3b4a6f8.svg";